module.exports = __webpack_public_path__ + "static/RODZINA-a80c4646521f5ac02beb0aa33b981f01.mp3";